import "../../../chunk-D57E6H3M.mjs";

// src/components/composite/ChatMarkdown/copyableCode.ts
import { createContext } from "react";
var CopyableCodesContext = createContext(false);
var CODE_PATTERN = /^(?=[\dA-Z_-]*[A-Z])[\dA-Z][\dA-Z_-]{3,31}$/;
function isCopyableCode(text) {
  return CODE_PATTERN.test(text);
}
export {
  CopyableCodesContext,
  isCopyableCode
};
//# sourceMappingURL=copyableCode.mjs.map